import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";

export async function getLastRefreshTimeDetails() {
  try {
    const responseDataText = await authenticatedFetch(`${URL.lastRefreshTimeDetails}`, {
      method: "GET",
    });

    return responseDataText;
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}